export function reoccurrence(node, _) {
    let lastreoccurredAt = undefined;
    let timeout = undefined;
    return {
        update(options) {
            if (options.toast.time.reoccurredAt !== lastreoccurredAt) {
                lastreoccurredAt = options.toast.time.reoccurredAt;
                options.in?.(node);
                timeout = setTimeout(() => options.out?.(node), options.duration ?? 300);
            }
        },
        destroy() {
            timeout && clearTimeout(timeout);
        }
    };
}
